'use es6';

import shallowEqual from 'react-utils/shallowEqual';
import { getBoundsFuncForConfig, getElementsFuncForConfig, getPositionLookupIdFuncForConfig, arrangeNodePositionSubsetById } from './nodePositionUtils';
const calculateBasicNodePositions = (nodeData, prevItemNodePositions, subConfig) => {
  const itemList = subConfig.getListFromNodeData(nodeData);
  const newItemNodePositions = [];
  const prevItemNodePositionsById = arrangeNodePositionSubsetById(prevItemNodePositions, subConfig);
  let anyNodePositionsChanged = false;
  if (itemList == null || typeof itemList[Symbol.iterator] !== 'function') {
    if (subConfig.debug) {
      console.log('getListFromNodeData did not return an iterable collection for ', subConfig.key);
    }
    // Check if we can preserve the reference and return prevItemNodePositions
    if (!prevItemNodePositions || prevItemNodePositions.length > 0) {
      anyNodePositionsChanged = true;
    }
  } else {
    const getElementsForConfig = getElementsFuncForConfig(subConfig);
    const getBoundsForConfig = getBoundsFuncForConfig(subConfig);
    const getPositionLookupId = getPositionLookupIdFuncForConfig(subConfig);
    itemList.forEach(item => {
      const elements = getElementsForConfig(item);
      if (elements.length) {
        elements.forEach((element, index) => {
          const bounds = getBoundsForConfig(element);
          if (bounds.hasBounds) {
            const customFields = subConfig.getCustomFields ? subConfig.getCustomFields({
              bounds,
              element,
              index,
              item
            }) : {};
            const newItemNodePosition = Object.assign({}, bounds, customFields);
            const prevItemNodePosition = prevItemNodePositionsById[getPositionLookupId(newItemNodePosition)];
            if (shallowEqual(newItemNodePosition, prevItemNodePosition)) {
              newItemNodePositions.push(prevItemNodePosition);
            } else {
              if (!anyNodePositionsChanged) {
                anyNodePositionsChanged = true;
              }
              newItemNodePositions.push(newItemNodePosition);
            }
          }
        });
      }
    });
  }
  const anyNodePositionsRemoved = prevItemNodePositions && prevItemNodePositions.length !== newItemNodePositions.length;
  if (subConfig.debug) {
    console.log('calculateBasicNodePositions result', {
      anyNodePositionsChanged,
      anyNodePositionsRemoved,
      key: subConfig.key,
      nodePositions: newItemNodePositions
    });
  }
  if (anyNodePositionsChanged || anyNodePositionsRemoved) {
    return newItemNodePositions;
  }
  return prevItemNodePositions;
};
export default calculateBasicNodePositions;